import { render, staticRenderFns } from "./DatosLaborales.vue?vue&type=template&id=651553c6&scoped=true&"
import script from "./DatosLaborales.vue?vue&type=script&lang=js&"
export * from "./DatosLaborales.vue?vue&type=script&lang=js&"
import style0 from "./DatosLaborales.vue?vue&type=style&index=0&id=651553c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651553c6",
  null
  
)

export default component.exports